export default __webpack_public_path__ + "static/media/open-health-network.4358a897.jpg";